import { HeroSlide } from '../components/HeroSlide'
import { HeroControls } from '../components/HeroControls'
import { useHeroSlider } from '../../hooks/useHeroSlider'
import { HERO_SLIDES, HERO_AUTOPLAY_MS } from '../../config/home.config'

export function HeroSlider() {
  const { index, next, prev, goTo } = useHeroSlider(HERO_SLIDES.length, HERO_AUTOPLAY_MS)
  const slide = HERO_SLIDES[index]

  return (
    <section className="relative w-full h-[420px] rounded-xl overflow-hidden shadow-card">
      <HeroSlide slide={slide} />
      <HeroControls
        total={HERO_SLIDES.length}
        index={index}
        onPrev={prev}
        onNext={next}
        onGoTo={goTo}
      />
    </section>
  )
}
